import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll';
// import { gsap } from 'gsap';

export default class ScrollLocking {
	constructor() {
		// Dom elements
		document.addEventListener('disable-scroll', () => {
			this.lock();
		});

		document.addEventListener('enable-scroll', () => {
			this.unlock();
		});
	}

	lock() {
		disablePageScroll();
	}

	unlock() {
		enablePageScroll();
	}
}
